import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface ThemeToggleProps {
  onClose?: () => void;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ onClose }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  const handleClick = () => {
    toggleTheme();
    if (onClose) {
      onClose();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`theme-toggle ${isDarkMode ? 'theme-toggle--dark' : ''}`}
      aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
      role="switch"
      aria-checked={isDarkMode}
    >
      <div className="theme-toggle__track">
        <svg className="theme-toggle__svg" viewBox="0 0 369 171.667">
          {/* Stars */}
          <polygon className="theme-toggle__star theme-toggle__star--1" fill="#A2B5BF" points="166.253,132.982 164.364,135.676 160.983,136.488 163.196,138.965 162.996,142.16 166.253,140.998 169.509,142.16 169.309,138.965 171.522,136.488 168.142,135.676" />
          <polygon className="theme-toggle__star theme-toggle__star--2" fill="#A2B5BF" points="175.522,44.243 172.684,48.29 167.603,49.51 170.929,53.233 170.628,58.035 175.522,56.288 180.417,58.035 180.116,53.233 183.442,49.51 178.361,48.29" />
          <polygon className="theme-toggle__star theme-toggle__star--3" fill="#A2B5BF" points="208.22,91.845 206.083,94.891 202.259,95.81 204.763,98.61 204.535,102.226 208.22,100.911 211.903,102.226 211.677,98.61 214.181,95.81 210.356,94.891" />
          
          {/* Moon */}
          <g className="theme-toggle__moon">
            <circle fill="#CAD9DD" cx="255.662" cy="85.825" r="45" />
            <circle fill="#A2B5BF" cx="262.446" cy="96" r="8" />
            <circle fill="#A2B5BF" cx="239.621" cy="75" r="6" />
            <circle fill="#A2B5BF" cx="270" cy="75" r="5" />
          </g>
          
          {/* Sun */}
          <g className="theme-toggle__sun">
            <circle fill="#F4E962" cx="255.661" cy="85.825" r="45" />
            <circle fill="#F9C941" cx="255.661" cy="85.825" r="40" />
          </g>
          
          {/* Cloud */}
          <path className="theme-toggle__cloud" fill="#ECF0F1" d="M153.269,109.614h2.813c-1.348-2.84-2.124-6.003-2.124-9.354c0-12.083,9.794-21.878,21.877-21.878c7.872,0,14.751,4.172,18.605,10.411c2.121-1.246,4.583-1.974,7.221-1.974c7.889,0,14.285,6.396,14.285,14.285c0,2.1-0.465,4.087-1.277,5.882h6.354c6.604,0,12.007,5.403,12.007,12.007s-5.403,12.006-12.007,12.006h-25.151H179.48h-26.212c-5.881,0-10.692-4.812-10.692-10.692S147.388,109.614,153.269,109.614z" />
        </svg>
      </div>
    </button>
  );
};

export default ThemeToggle;

